import { ReactComponent as AppleLogo } from 'img/nestleLanding/Apple_Icon.svg';
import { ReactComponent as GoogleLogo } from 'img/nestleLanding/Google_Icon.svg';
import { ReactComponent as HuaweiLogo } from 'img/nestleLanding/Huawei_Icon.svg';
import { ReactComponent as RuStoreLogo } from 'img/nestleLanding/RuStore_Icon.svg';
import { ReactComponent as FourSixStars } from 'img/sass-landing/icons/4_6stars.svg';
import { ReactComponent as FiveStars } from 'img/sass-landing/icons/5stars.svg';
import React from 'react';

import styles from './Rating.css';

export const Rating = () => {
    return (
        <div className={styles.root}>
            <a href="https://apps.rustore.ru/app/ru.mail.cloud" rel="nofollow" className={styles.item}>
                <RuStoreLogo width="38" height="38" />
                <span className={styles.value}>4.8</span>
                <FiveStars width="95" height="19" />
            </a>
            <a href="https://trk.mail.ru/c/muv7c7" className={styles.item}>
                <AppleLogo width="38" height="38" />
                <span className={styles.value}>4.8</span>
                <FourSixStars width="95" height="19" />
            </a>
            <a href="https://appgallery8.huawei.com/#/app/C101034901" rel="nofollow" className={styles.item}>
                <HuaweiLogo width="38" height="38" />
                <span className={styles.value}>4.7</span>
                <FiveStars width="95" height="19" />
            </a>
            <a href="https://trk.mail.ru/c/pbnfy7" className={styles.item}>
                <GoogleLogo width="38" height="38" />
                <span className={styles.value}>4.6</span>
                <FourSixStars width="95" height="19" />
            </a>
        </div>
    );
};
